import {
  FETCH_REPAIR_TICKETS,
  REPAIR_TICKETS_LOADING,
} from '../actions/repairTickets';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_REPAIR_TICKETS:
      return {
        ...state,
        marketRepairTickets: action.payload,
      };
    case REPAIR_TICKETS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
}
